import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/automobilitytab/shutterstock_2450817821.jpg';
import galleryImg2 from '../img/envision/dropdown/new/automo.png';
import galleryImgs31 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg41 from '../img/envision/dropdown/new/cmd.jpg';

const galleryImages = [galleryImg1, galleryImg2];
const galleryImagess = [galleryImgs31, galleryImg41];

const MobilitypageData = () => {
    const [currentImage, setCurrentImage] = useState(galleryImages[0]);
    const [currentImages, setCurrentImages] = useState(galleryImagess[0]);

    // Function to cycle through images in galleryImages (first gallery)
    const changeFirstImage = () => {
        setCurrentImage((prevImage) => {
            const currentIndex = galleryImages.indexOf(prevImage);
            return galleryImages[(currentIndex + 1) % galleryImages.length];
        });
    };

    // Function to cycle through images in galleryImagess (second gallery)
    const changeSecondImage = () => {
        setCurrentImages((prevImage) => {
            const currentIndex = galleryImagess.indexOf(prevImage);
            return galleryImagess[(currentIndex + 1) % galleryImagess.length];
        });
    };

    // useEffect for cycling through galleryImages (first image set)
    useEffect(() => {
        const intervalId = setInterval(changeFirstImage, 3000); // Change image every 3 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // useEffect for cycling through galleryImagess (second image set)
    useEffect(() => {
        const intervalId = setInterval(changeSecondImage, 4000); // Change image every 4 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section style={{ marginTop: '40px', backgroundColor:'#fff' }}>
            <div className="container">
                

                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(236 115 34)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                      Automotive, Rail, and  <span style={{color:'#000'}}>Next-Gen Mobility</span>  
                             
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                Revolutionizing Automotive, Rail, and Next-Gen Mobility with resilient, innovative, and future-ready technologies  .

                                At DREBCON, we empower the Automotive, Rail, and Next-Gen Mobility industries by addressing critical challenges in cybersecurity and ensuring seamless compliance with global regulatory standards, enabling organizations to secure their systems, protect sensitive data, and accelerate innovation in smart and sustainable transportation.
                                </p>
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                
Our expertise extends to securing Electric Vehicle (EV) ecosystems, integrating advanced IT and OT security frameworks to protect SCADA, ICS, and IIoT environments across EV manufacturing, charging infrastructure, and mobility solutions. By embedding robust governance models and intelligent risk management systems, we mitigate cyber threats, enhance system reliability, and ensure compliance with regulations like UNECE WP.29, NIST, GDPR, and global EV standards.
 
                                 </p>

                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                               
With a focus on secure, compliant, and future-ready solutions, DREBCON enables Automotive, Rail, and EV industries to thrive in an interconnected, data-driven, and rapidly evolving global marketplace, driving sustainability, innovation, and trust in next-generation mobility.

                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg1} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%', marginTop:'40px' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MobilitypageData;
